"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const Check_1 = require("../check/Check");
function isMessageMeta(object) {
    return checkMessageMeta(object).fulfilled;
}
exports.isMessageMeta = isMessageMeta;
function checkMessageMeta(object, options = { ignoreSuperfluousObjectProperties: true }) {
    return Check_1.check(object, Check_1.hasString("messageId"), Check_1.hasString("projectId"), Check_1.hasArray("autoTags", Check_1.isString())).withOptions(options).explain();
}
exports.checkMessageMeta = checkMessageMeta;
//# sourceMappingURL=MessageMeta.js.map